export enum PageRoutes {
	Gateway = '/',
	GatewayParking = '/parking',

	// Generic
	Flights = '/flights',
	ShopDineRelax = '/shop-dine-relax',
	Search = 'search',

	// IAH
	IAHHome = '/iah',
	IAHParkingAvailability = '/iah/parking',
	IAHFlights = '/iah/flights',
	IAHFlightDetailsArrival = '/iah/flights/arrival',
	IAHFlightDetailsDeparture = '/iah/flights/departure',
	IAHShopDineRelax = '/iah/shop-dine-relax',
	IAHSecurity = '/iah/security',
	IAHMap = '/iah/map',
	IAHInternationalTravel = 'iah/international-travel',
	IAHInternationalProcessing = 'iah/international-processing',
	IAHExploreDestinations = 'iah/explore-destinations',
	IAHWifi = 'iah/wifi',

	// HOU
	HOUHome = '/hou',
	HOUParkingAvailability = '/hou/parking',
	HOUFlights = '/hou/flights',
	HOUFlightDetailsArrival = '/hou/flights/arrival',
	HOUFlightDetailsDeparture = '/hou/flights/departure',
	HOUShopDineRelax = '/hou/shop-dine-relax',
	HOUSecurity = '/hou/security',
	HOUMap = '/hou/map',
	HOUInternationalTravel = 'hou/international-travel',
	HOUInternationalProcessing = 'hou/international-processing',
	HOUExploreDestinations = 'hou/explore-destinations',
	HOUWifi = 'hou/wifi',

	// EFD / Spaceport / HAS Corporate
	EFDHome = '/ellington',
	SpaceportHome = '/spaceport',
	CorporateHome = '/airport-business',
	CorporateNewsroom = '/airport-business/newsroom',
	CorporateNewsroomNews = '/airport-business/newsroom/articles',
	CorporateNewsroomNewsItem = '/airport-business/newsroom/articles/item',
	CorporateNewsroomNewsletters = '/airport-business/newsroom/newsletters',
	CorporateNewsroomPressReleases = '/airport-business/newsroom/press-releases',
	CorporateNewsroomMediaCenter = '/airport-business/newsroom/media-center',
	CorporateNewsroomMediaGallery = '/airport-business/newsroom/media-center/gallery',
	CorporateContact = '/airport-business/contact',
	CorporateSolicitations = '/airport-business/business-partnerships/contracting/solicitations',
	CorporateSolicitationsDetails = '/airport-business/business-partnerships/contracting/solicitations/details',
}
